import { map } from 'lodash';

class ActivityListController {

    constructor($stateParams, $scope, $timeout, activitiesService, messageService, access) {
        this.$scope = $scope;
        this.activitiesService = activitiesService;
        this.messageService = messageService;
        this.access = access;
        this.$stateParams = $stateParams;
    }

    $onInit () {
        this.filtertext = this.$stateParams.filtertext || null;
        if (this.filtertext) {
            this.isFiltered = true;
        }

        this.updatePaging();

        this.watchCurrentPage();
    }

    updatePaging () {
        this.$scope.per_page = this.activities.per_page;
        this.$scope.current_page = this.activities.current_page;
        this.$scope.total = this.activities.total;
    }

    watchCurrentPage () {
        this.$scope.$watch(() => this.$scope.current_page, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (this.filtertext && this.filtertype && this.isFiltered) {
                    this.activities = undefined;
                    this.loading = true;
                    return this.activitiesService.search(this.filtertype, this.filtertext, newVal).then(response => {
                        this.activities = response;
                        this.loading = false;
                    });
                } else {
                    this.activitiesService.findAll(newVal, this.$scope.per_page)
                        .then(list => this.activities = list);
                }
            }
        });
    }

    onDelete (activity) {
        return this.activitiesService.delete(activity.id)
            .then(() => {
                this.messageService.success(`The activity <strong>${activity.name}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The activity <strong>${activity.name}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.activities.current_page;
                this.activities = [];
                this.loading = true;
                return this.activitiesService.findAll(page).then(response => {
                    this.activities = response;
                    this.loading = false;
                });
            });
    }

    toggleActive (activity) {
        this.activitiesService.toggleActive(activity.id)
            .catch(error => {
                this.messageService.failure(`The activity <strong>${activity.name}</strong> could not be successfully toggled (active): ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => activity.status = !activity.status);
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.activitiesService.search(this.filtertype, this.filtertext).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.activitiesService.findAll(1, 20).then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            case 'cat':
                this.filtertext = this.categories.flat[0].id;
                break;
            case 'status':
                this.filtertext = '1';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    startFilter () {
        this.activities = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.activities = response;
        this.updatePaging();
        this.loading = false;
    }

    updatePriority (oldPriority, event) {
        if (!event || !event.priority || oldPriority === 'loading') {
            return false;
        }
        this.updateWait(event);
    }

    updateWait (item) {
        if (item.priority.match(/[^0-9]+/g)) return;
        item.updating = false;
        clearTimeout(item.trigger);
        item.trigger = setTimeout(() => { this.trigger(item); }, 1000);
    }

    update (item) {
        this.trigger(item);
    }

    trigger (item) {
        item.trigger = undefined;
        item.updating = true;

        this.activitiesService.updatePriority(item).then(() => {
            item.updating = false;
        });
    }
}

ActivityListController.$inject = ['$stateParams', '$scope', '$timeout', 'activitiesService', 'messageService', 'access'];

export default ActivityListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/controllers/activity.list.controller.js